import { RuleAction } from '../enums/POR/RuleAction';
import { RuleOperation } from '../enums/POR/RuleOperation';
import { PortOpeningRequestsDirection } from '../enums/POR/PortOpeningRequestsDirection';


export default class PortOpeningRuleOnPrem {
    id!: number;

	portOpeningRequestOnPremId!: number;

	action!: RuleAction;

	operation!: RuleOperation;

	description!: string;

	sourceIPs!: string;

	destinationIPs!: string;

	destinationURLs!: string;

	sourcePorts!: string;

	protocol!: string;

	name!: string;

    azureName!: string;

    direction!: PortOpeningRequestsDirection;

	destinationPorts!: string;

	sslBypass!: boolean;

	constructor(obj: any) {
		Object.assign(this, obj);
		this.direction = new PortOpeningRequestsDirection().fromValue(obj.direction?.value);
	}
}